namespace TabAurous.ECommerce {
    export interface ECommSalesGiftVoucherRow {
        TransGiftId?: number;
        TransId?: number;
        GiftMasterId?: number;
        UniqueCode?: string;
        Value?: number;
        Amount?: number;
        Expiry?: string;
        Quantity?: number;
        IsPartial?: boolean;
    }

    export namespace ECommSalesGiftVoucherRow {
        export const idProperty = 'TransGiftId';
        export const nameProperty = 'UniqueCode';
        export const localTextPrefix = 'ECommerce.ECommSalesGiftVoucher';
        export const deletePermission = 'EComm:ECommSales:Delete';
        export const insertPermission = 'EComm:ECommSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommSales:Edit';

        export declare const enum Fields {
            TransGiftId = "TransGiftId",
            TransId = "TransId",
            GiftMasterId = "GiftMasterId",
            UniqueCode = "UniqueCode",
            Value = "Value",
            Amount = "Amount",
            Expiry = "Expiry",
            Quantity = "Quantity",
            IsPartial = "IsPartial"
        }
    }
}
